import router from '@/router/routes';
import getEditorData from '@/store/Common/getEditorData';
import saveEditorData from '@/store/Common/saveEditorData';
import destroyEditorData from '@/store/Common/destroyEditorData';
import commitFieldOptions from '@/store/Modules/Field/common/commitFieldOptions';

const actions = {
    getData({ commit, getters, state }) {
        return new Promise (resolve => {
            commit('overlay/toggle', true, { root: true });
            commit('setFieldId', router.currentRoute.params.id ? router.currentRoute.params.id : 0);

            getEditorData(getters.route).then((response) => {
                commit('setTypes', response.data.data.types);
                commit('setCards', response.data.data.cards);
                if (!state.fieldId) {
                    commit('setCard', '');
                    commit('setCardData', {});
                    commit('setSection', '');
                    commit('setSectionData', {});
                    commit('setStep', '');
                    commit('setStepData', {});
                    commit('setPage', '');
                    commit('setPageData', {});
                    commit('setType', '');
                    commit('setName', undefined);
                    commit('setOrder', 0);
                    commit('setPublished', 0);
                    commit('setLevel', 'support');

                    // Options
                    commit('setHelpText', undefined);
                    commit('setHelpTitle', undefined);
                    commit('setUploaderInstructionText', undefined);
                    commit('setAudio', undefined);

                    commit('setFieldsInGroup', 1);
                    commit('setGroupNumbered', false);
                    commit('setGroupInline', false);
                    commit('setOptionsGroup', undefined);

                    commit('setStaticText', undefined);
                    commit('setUpsell', undefined);
                    commit('setCustomColorAccessLevel', undefined);
                    commit('setCustomColorUpsell', undefined);
                    commit('setCustomFontAccessLevel', undefined);
                    commit('setCustomFontUpsell', undefined);
                    commit('setPreviewHeroHeadline', undefined);
                    commit('setPreviewHeroSubhead', undefined);
                    commit('setPreviewHeroButtonText', undefined);
                    commit('setPreviewBanner1', undefined);
                    commit('setPreviewBanner2', undefined);
                    commit('setPreviewBanner3', undefined);
                    commit('setPreviewBodyHeadline', undefined);
                    commit('setPreviewBodyCopy', undefined);
                    commit('setPreviewBodyButtonText', undefined);
                    commit('setPreviewHeroImage', undefined);
                    commit('setPreviewHeadshot', undefined);
                    commit('setTrainingDescription', undefined);
                    commit('setTrainingVideoThumbnail', undefined);
                    commit('setTrainingVideoId', undefined);
                    commit('setTrainingDownloadId', undefined);
                    commit('setTrainingDownloadURL', undefined);
                    commit('setLoadStock', 'no');
                    commit('setUploadType', 'image');
                    commit('setShowUploadButton', 'no');
                    commit('setShowSelectButton', 'no');
                    commit('setHeroSelectorLabel', 'Hero Background');
                    commit('setHeroSelectorChoiceOne', 'Image');
                    commit('setHeroSelectorChoiceTwo', 'Theme Color');
                    commit('setTemplateSelectorLabel', 'Sample Color Scheme');
                    commit('setTemplateSelectorColorOne', '#ef6067');
                    commit('setTemplateSelectorColorTwo', '#366780');
                    commit('setTemplateSelectorColorThree', '#f5f5f5');
                    commit('overlay/toggle', false, { root: true });
                    return;
                }
                const field = response.data.data.field;

                if (!field || !field.id) {
                    commit('overlay/toggle', false, { root: true });
                    return;
                }

                commit('setName', field.name);
                commit('setType', field.type);
                commit('setOrder', field.order);
                commit('setPublished', field.published);
                commit('setCard', field.card_id);
                commit('setCardData', field.card);
                commit('setSection', field.card.section ? field.card.section.id : null);
                commit('setSectionData', field.card.section ? field.card.section : []);
                commit('setStep', field.card.section && field.card.section.step ? field.card.section.step.id : null);
                commit('setStepData', field.card.section && field.card.section.step ? field.card.section.step : []);
                commit('setPage', field.card.page ? field.card.page.id : null);
                commit('setPageData', field.card.page ? field.card.page : []);
                commit('setPopulations', field.population);
                commit('setLevel', field.level);

                if (field.options) {
                    commitFieldOptions(field, commit);
                }

                commit('overlay/toggle', false, { root: true });
                resolve();
            });
        });
    },

    saveData({ getters, commit }) {
        saveEditorData('field', getters.route, getters.postData)
            .then((fieldId) => {
                if (router.currentRoute.name === 'FieldEdit') {
                    commit('overlay/toggle', false, { root: true });
                } else {
                    router.push('/field/edit/' + fieldId);
                }
            })
            .catch(() => {});
    },

    destroyData({ state }) {
        destroyEditorData('/api/field/delete/' + state.fieldId)
            .then(() => {
            })
            .catch(() => {
            });
    }
};

export default actions;
